import { onMounted, ref } from 'vue';

export const useFetch = (callback: () => Promise<unknown> | unknown) => {
  const isLoading = ref(false);

  onMounted(async () => {
    isLoading.value = true;

    await callback();

    isLoading.value = false;
  });

  return {
    isLoading,
  };
};
